import { StyleSheet } from 'aphrodite';

const styles = StyleSheet.create({
    flex: {
        display: 'flex',
        flexDirection: 'column',
    },
    flexRow: {
        display: 'flex',
        flexDirection: 'row',
    },
    background: {
        backgroundColor: 'white',
    },
    absolute: {
        position: 'absolute',
        top: 0,
        bottom: 0,
        left: 0,
        right: 0,
    }
});

export default styles;